import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-close-report-list',
  templateUrl: './close-report-list.component.html',
  styleUrls: ['./close-report-list.component.css']
})
export class CloseReportListComponent implements OnInit {

  @Input() selectedRegion: string;
  @Input() selectedDistrict: string;

  route:string;
  regionLoader = false;
  industryLoader = false;
  historyLoader = false;
  firstLevel:any = [];
  closeIndustryList = [];
  regionList = [];
  districtList = [];
  industryParameterList = [];
  closeIndustryHistory = [];
  selectedOfficerName = '';
  selectedRegionName = '';
  moreDetailDrilled = false;
  selectedIndustryName = '';
  selectedIndustryAddress = '';

  regionFilter = '';
  districtFilter   = '';


  startReportDate:Date;
  endReportDate = new Date();
  currentReportDate = new Date();
  oneDayBeforeDate = new Date();
  maxStartDate : Date;
  maxEndDate : Date;

  startReportTime: Date;
  endReportTime: Date;

  startDate = '';
  endDate = '';
  startTime = '';
  endTIme = '';

  userData:any = [];

  userName;
  userLevel;
  searchField = {};
  i=0;
  constructor(private activeroute: ActivatedRoute,private router: Router,
              private _service: CommonService) {
    this.maxStartDate = new Date();
    this.maxEndDate = new Date();
  }

  ngOnInit() {

    this.i=0;
    var d = new Date();
    d.setDate(d.getDate());
    this.startReportDate = d;

    this.userData = JSON.parse(localStorage.getItem('userData'));

    if(this.userData){
      this.userName = this.userData['user_profile_id'];
      this.userLevel = this.userData['access_level'];
    }

    if(this.userLevel == 'industry'){
      this.searchField['industryId'] = this.userName;
    }

    if(this.userLevel == 'vendor'){
      this.searchField['vendorId'] = this.userData['id']?this.userData['id']:'';
    }
    if(!this.i) {
      this.getRegionList();
    }
    this.getCloseIndustry();
  }


  onStartDateChange(value: Date): void {
    this.startReportDate = value;
    // this.endReportDate = this.startReportDate;
  }

  onEndDateChange(value: Date): void {
    this.endReportDate = value;
  }

  getRegionList(){

    this.route  = 'get-region-list';
    const token = localStorage.getItem('userToken');

    let data = [];

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.regionList = response.data;
        this.regionFilter = response.data[0].region_name;
        if(this.i==0){
          this.getCloseIndustry();
          this.i=1;
        }
      }
    });
  }

  getDistrictList(){

    this.route  = 'get-all-city-list';
    const token = localStorage.getItem('userToken');

    let data = [];

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.districtList = response.data;
      }
    });
  }

  getCloseIndustry(){

    if(this.startReportDate){
      this.startDate = this.convertDateFormat(this.startReportDate)
    }

    if(this.endReportDate){
      this.endDate = this.convertDateFormat(this.endReportDate)
    }

    if(this.startReportTime){
      this.startTime = this.convertTimeFormat(this.startReportTime)
    }

    if(this.endReportTime){
      this.endTIme = this.convertTimeFormat(this.endReportTime)
    }

    this.regionLoader = true;
    this.route  = 'get-report-close_industry';
    const token = localStorage.getItem('userToken');

    let data = {'region':this.regionFilter, 'startDate':this.startDate,'endDate':this.endDate,'startTime':this.startTime, 'endTIme': this.endTIme, 'search_fields': this.searchField};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){
        this.firstLevel = response.result;
      }
      this.regionLoader = false;
    });
  }

  getCloseIndustryList(regionName,officerName){

    this.industryLoader = true;
    this.moreDetailDrilled = false;
    this.selectedRegionName = regionName;
    this.selectedOfficerName = officerName;

    this.route  = 'get-close_industry-list';
    const token = localStorage.getItem('userToken');

    let data = {'region_name':regionName, 'startDate':this.startDate,'endDate':this.endDate,'startTime':this.startTime, 'endTIme': this.endTIme, 'search_fields': this.searchField};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){
        this.closeIndustryList = response.data;
        this.industryParameterList = response.parameter;
      }
      this.industryLoader = false;
    });
  }

  getIndustryCloseTimeWise(industryName,industryAddress,industryId){

    this.historyLoader = true;
    this.moreDetailDrilled = true;
    this.selectedIndustryName = industryName;
    this.selectedIndustryAddress = industryAddress;

    this.route  = 'get-close-industry-history';
    const token = localStorage.getItem('userToken');

    let data = {'industry_id':industryId, 'startDate':this.startDate,'endDate':this.endDate,'startTime':this.startTime, 'endTIme': this.endTIme};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){
        this.closeIndustryHistory = response.data;
      }
      this.historyLoader = false;
    });

  }

  convertDateFormat(dateObj) {

    var result_date = new Date(dateObj);

    var str = result_date.getFullYear() + '-' +
        ((result_date.getMonth()+1) > 9 ? (result_date.getMonth()+1) : ('0'+(result_date.getMonth()+1)))
        + '-' +
        (result_date.getDate() > 9 ? result_date.getDate() : ('0'+result_date.getDate()));

    return str;
  }

  convertTimeFormat(timeObj) {

    if(timeObj){
      var result_time = new Date(timeObj);

      return ((result_time.getHours()) > 9 ? (result_time.getHours()) : ('0'+(result_time.getHours()))) + ':' + ((result_time.getMinutes()) > 9 ? (result_time.getMinutes()) : ('0'+(result_time.getMinutes()))) + ':00';
    }else{
      return '00:00:00'
    }
  }

  backToPreviousLevel(){
    this.moreDetailDrilled = false;
  }

}
